exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-notification .ant-notification-notice-message{display:none}.ant-notification .ant-notification-notice-with-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.ant-notification .ant-notification-notice{color:#fff}.ant-notification .ant-notification-notice:after{content:\"\";position:absolute;right:10px;top:25%;width:1px;height:50%;background-color:#fff}.u_notification_success{background-color:#68d675}.u_notification_success .anticon{color:#4ead59;font-size:24px}.u_notification_error{background-color:#ff6547}.u_notification_error .anticon{color:#cf3e21;font-size:24px}.u_notification_info{background-color:#4f88fe}.u_notification_info .anticon{color:#3962b8;font-size:24px}.ant-notification-notice-close{top:10px;right:10px}.ant-notification-notice-close .anticon-close{font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Notification/index.scss
// module id = 969
// module chunks = 0